export default __webpack_public_path__ + "static/media/Educating.490fac3d.jpg";